import {LevelLog} from '../models/enum/levelLog';
import {environment} from '../../../environments/environment';
import { Injectable } from "@angular/core";

/**
 * Utility for everything related to traces
 */
@Injectable()
export class LoggerHelper {

  /**
   *
   * @param text String or object to be traced
   * @param level verbosity of writing
   * @param always write condition
   * @example
   *  LoggerHelper.print('string');
   */
  public static print(text: any,
                      level: LevelLog = LevelLog.INFO,
                      always: boolean = false) {
    if (!environment.production || always) {
      console[level](text);
    }
  }
}
